import { render, staticRenderFns } from "./EventHistory.vue?vue&type=template&id=6baeb9da&scoped=true"
import script from "./EventHistory.vue?vue&type=script&lang=js"
export * from "./EventHistory.vue?vue&type=script&lang=js"
import style0 from "./EventHistory.vue?vue&type=style&index=0&id=6baeb9da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baeb9da",
  null
  
)

export default component.exports